import { AgentFinanceWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentFinanceApi = new AgentFinanceWebService.FinanceApi(config);

export default agentFinanceApi;
